/**
 * Controls hint + start prompt + always-visible menu button + minimap.
 */
import { V, bt, Ct } from "./dom.js";
import { createMinimap } from "./minimap.js";

export const Tt = 9e3;

export function Et(e, t) {
    if (e === `touch`) return [
        [
            [], `Left thumb to walk, push further to run`
        ],
        [
            [], `Right thumb to look`
        ]
    ];
    let n = e === `gamepad`,
        r = [
            [n ? [Ct(`L`)] : [`W`, `A`, `S`, `D`].map(e => Ct(e)), `Move`],
            [
                [Ct(n ? `R` : `Mouse`)], `Look`
            ],
            [
                [Ct(n ? `RT` : `Shift`)], `Sprint`
            ],
            [
                [n ? Ct(`A`, `pad-a`) : Ct(`Space`)], `Jump`
            ],
            [
                [Ct(n ? `R3` : `Tab`)], `First person`
            ]
        ];
    return t && r.push([n ? [Ct(`✚`)] : [`←`, `↑`, `→`, `↓`].map(e => Ct(e)), `Dance`]), r
}
export class Dt {
    el;
    menuBtn;
    minimap;
    hint = V(`div`, {
        class: `controls-hint`
    });
    start = V(`div`, {
        class: `start-prompt panel`
    });
    hintTimer = 0;
    shown = null;
    /**
     * @param {() => void} [onMenu]
     */
    constructor(onMenu) {
        this.menuBtn = V(`button`, {
            class: `hud-menu interactive`,
            type: `button`,
            "aria-label": `Menu`
        }, bt(`menu`));
        this.menuBtn.addEventListener(`click`, (e) => {
            e.preventDefault(), e.stopPropagation(), onMenu?.()
        });
        this.minimap = createMinimap();
        this.el = V(`div`, {
            class: `hud`
        }, this.minimap.el, this.hint, this.start, this.menuBtn)
    }
    setMenuHidden(e) {
        this.menuBtn.classList.toggle(`hidden`, !!e)
    }
    /** @param {number} x @param {number} z @param {number} facing */
    setMapPlayer(x, z, facing) {
        this.minimap?.setPlayer(x, z, facing)
    }
    controls(e, t) {
        if (this.shown?.device === e && this.shown.club === t) return;
        this.shown = {
            device: e,
            club: t
        }, this.hint.classList.toggle(`touch`, e === `touch`);
        let n = Et(e, t);
        this.hint.replaceChildren(...n.map(([e, t]) => V(`div`, null, ...e, V(`span`, null, t)))), this.hint.classList.toggle(`fade`, e === `touch` && t), clearTimeout(this.hintTimer), this.hintTimer = window.setTimeout(() => this.hideControls(), Tt)
    }
    followDevice(e) {
        this.shown && e !== this.shown.device && !this.hint.classList.contains(`fade`) && this.controls(e, this.shown.club)
    }
    hideControls() {
        this.hint.classList.add(`fade`)
    }
    startPrompt(e) {
        e && this.start.replaceChildren(bt(`headphones`), V(`span`, null, e)), this.start.classList.toggle(`show`, !!e)
    }
}

export { Dt as Hud };
